<template>
  <div>
    <b-field :label="label">
      <div class="columns is-vcentered" >
        <b-datepicker
          v-model="periode.dateDebut"
          :max-date="periode.dateFin"
          :disabled="disabled"
          class="column"
          icon="calendar-today"
          :position="`is-${orientation}-right`"
          nearby-selectable-month-days
          show-week-number editable>
        </b-datepicker>
        <span class="column is-1 has-text-centered">
          {{$t('general.au')}}
        </span>
        <b-datepicker
          v-model="periode.dateFin"
          :min-date="periode.dateDebut"
          :disabled="disabled"
          class="column"
          icon="calendar-today"
          :position="`is-${orientation}-left`"
          nearby-selectable-month-days
          show-week-number editable>
        </b-datepicker>
      </div>
    </b-field>
  </div>
</template>

<script>
export default {
  name: 'inputPeriode',
  props: {
    value: {
      type: Object,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
    },
    orientation: {
      type: String,
      required: false,
      default: 'bottom',
    },
  },
  computed: {
    periode: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },
};
</script>
